import FrequencyAPI from "../../../api/FrequencyAPI";
import Frequency from '../../../models/frequency/Frequency';

export default {
  async loadAllFrequencies({
    commit
  }) {
    const response = await new FrequencyAPI().all();
    const result = [];
    for (let i = 0; i < response.length; i++) {
      result.push(Frequency.createFromData(response[i]))
    }
    commit("SET_ALL_FREQUENCIES", result);
  },

  async loadLeaseFrequency({
    commit
  }) {
    const response = await new FrequencyAPI().getLeaseFrequency();
    const result = [];
    for (let i = 0; i < response.length; i++) {
      result.push(Frequency.createFromData(response[i]))
    }
    commit("SET_LEASE_FREQUENCIES", result);
  },
};
